



































import { namespace } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import AuctionBWizardHeader from '@/UI/AuctionB/AuctionBWizardHeader.vue'
import PersonalData from '@/UI/AuctionB/PersonalData/PersonalData.vue'
import Declarations from '@/UI/AuctionB/Declarations/Declarations.vue'
import { EventBus } from '@/Infrastructure/EventBus/EventBus'
import { SendEncryptedXmlOfferCommandHandlerProvider } from '../../Infrastructure/XmlOffer/Provider'
import { SendEncryptedXmlOfferCommand } from '../../Application/XmlOffer'
import { ProcedureDto } from '../../Application/Procedures'
import AuctionBModals from '@/UI/AuctionB/AuctionBModals.vue'
import Footer from '@/UI/AuctionB/AuctionBFooter.vue'
import VModal from 'vue-js-modal'
import AuctionBGeneratePDFs from '@/UI/AuctionB/AuctionBGeneratePDFs.vue'
import { SendEncryptedOfferResponseDto } from '@/Application/XmlOffer/SendEncryptedOfferResponseDto'
import { PersonalData as VuexPersonalData } from '@/Infrastructure/Store/Auction/PersonalData'
import { MessageAlert } from '@/Domain/MessageAlert'

Vue.use(VModal)

const auctionStore = namespace('auction')
const auctionStoreB = namespace('auctionb')
const accountStore = namespace('account')
const procedureStore = namespace('procedure')

@Component({
  components: {
    AuctionBWizardHeader,
    PersonalData,
    Declarations,
    Footer,
    AuctionBModals,
    AuctionBGeneratePDFs
  }
})
export default class AuctionB extends Vue {
  loading = false
  loadingGeneral = false
  continuar = false
  validForm = false
  finishForm = false
  currentStep = 1
  lastValidatedStep = 1
  lastStep = 2
  url = ''
  validQuery = true

  @accountStore.Getter
  public username!: string

  @auctionStore.Getter
  public personalData!: VuexPersonalData

  @auctionStore.Getter
  public procedureData!: string[]

  @procedureStore.Getter
  public currentProcedure!: ProcedureDto

  @auctionStoreB.Getter
  public lastWizardStep!: number

  @auctionStoreB.Action
  public setLastWizardStep!: (number: number) => void

  @auctionStoreB.Action
  public clearOffers!: () => void

  @auctionStoreB.Action
  public setResultPost!: (resultPost: SendEncryptedOfferResponseDto) => void

  @auctionStoreB.Action
  public clearAuctionAll!: () => void

  public mounted (): void {
    if (this.procedureData.length === 0) {
      this.$router.push({ name: 'Home' })
    }
  }

  public onWizardFinished (): Promise<void> {
    EventBus.$emit('loading', true)
    const provider = new SendEncryptedXmlOfferCommandHandlerProvider()
    const handler = provider.provide()
    const command = new SendEncryptedXmlOfferCommand(
      this.currentProcedure.procedureId,
      this.procedureData.sort().join('-'),
      this.personalData.nif,
      this.username
    )
    return handler.handle(command)
      .then(response => {
        this.validQuery = true
        this.url = response.sedeUrl
        this.setResultPost(response)
        this.showPdfsModal()
      })
      .catch((error) => {
        this.validQuery = false
        console.log(error)
        const message = this.$t('shared.apiErrors.error_code_auction_b_generic')
        EventBus.$emit('messageAlert', new MessageAlert(message.toString(), 'error'))
      })
      .finally(() => {
        EventBus.$emit('loading', false)
      })
  }

  public showPdfsModal ():void {
    this.$modal.show('pdfsModal')
  }

  public clearAllVuex (): void {
    this.clearAuctionAll()
  }
}
